 
<template>
  <div class="menu-container">
    <!-- <div class="grid grid-cols-5">
      <div @click="handleClick(item)" class="menu-item" v-for="(item,key) in quickMenu">
        <div class="menu-item-icon">
          <a-icon :type="item.permissionIcon||'menu'" />
        </div>
        <div class="menu-item-title">{{item.permissionName}}</div>
      </div>
    </div>-->

    <div class="menu-box flex">
      <div @click="handleClick(item)" class="menu-item" v-for="(item,key) in quickMenu">
        <div class="menu-item-icon">
          <a-icon :type="item.permissionIcon||'menu'" />
        </div>
        <div class="menu-item-title">{{item.permissionName}}</div>
      </div>
    </div>
    <menu-modal ref="menuModal" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridMixins from '../mixins/GridMixins'
  import MenuModal from './menuModal.vue'
  export default {
    name: 'QuickMenu',
    components: {
      MenuModal
    },

    mixins: [GridMixins],
    // 定义属性
    data () {
      return {
        defaultLoad: false
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['quickMenu', 'userRoutes'])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      openModal () {
        this.$refs.menuModal.show()
      },
      handleClick (item) {
        // 修复iframe菜单跳转的问题，path路径从router里面拼接获取
        const { path } = this.userRoutes.get(item.permissionId)
        if (!path) {
          this.$message.error('菜单数据有误，请联系管理员')
          return
        }
        this.$router.push({ path })
      }
    }
  }
</script>

<style lang='less' scoped>
  .menu-box {
    flex-wrap: wrap;
  }
  .menu-item {
    // flex: 1;
    // flex-direction: column;
    // padding: 5px;
    // justify-content: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px;
    padding: 10px;
    border-radius: 8px;
    text-align: center;
    &:hover {
      cursor: pointer;
      -webkit-box-shadow: 0 0 15px #ededed;
      box-shadow: 0 0 15px #ededed;
    }
    &-icon {
      // width: 50px;
      // height: 50px;
      // border-radius: 50%;
      // background: #eeeeee;
      // text-align: center;
      // justify-content: center;
      // align-items: center;
      // display: flex;
      position: relative;
      display: flex;
      overflow: hidden;
      width: 60px;
      height: 60px;
      background: #f2f6fc;
      border-radius: 50%;
      .anticon {
        margin: auto;
        font-size: 24px;
        color: rgb(24, 144, 255);
      }
    }
    &-title {
      font-size: 14px;
      color: #333;
      margin-top: 5px;
    }
  }
</style>